import { withInstall } from '@hd-front-end/utils'
import Scrollbar from './src/scrollbar.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElScrollbar: SFCWithInstall<typeof Scrollbar> =
  withInstall(Scrollbar)
export default ElScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
export * from './src/constants'
